import PropTypes from 'prop-types';
import React from 'react';
import BottomSheet from '../../../components/bottomsheet/BottomSheet';
import PrimaryButton from '../../../components/buttons/primarybutton/PrimaryButton';
import Card from '../../../components/card/Card';
import H1 from '../../../components/text/H1';
import { tag } from '../../../services/ATInternetService';

const UnlockedCardMessage = ({ card, foundAt, score, openCollection, goBack }) => {
	return <BottomSheet padding className="text-center overflow-visible" allowOverflow>
		<div className="transform -translate-y-12">
			<div className="w-full" style={{ height: '45vh', }}>
				<Card cardId={card.id} foundAt={foundAt} score={score} centered />
			</div>
			{openCollection && <>
				<H1 xl className="text-center pt-6 pb-4">Je hebt een{score === 6 ? ' speciale' : ''} kaart verzameld!</H1>
				{openCollection && <PrimaryButton onClick={() => {
					openCollection();
					tag.sendClick('unlocked-card', {
						chapter3: card.id,
						name: 'opened-collection',
					});
				}}>Verzameling</PrimaryButton>}
			</>}
			{goBack && <>
				<H1 xl className="text-center pt-6 pb-4">{score === 6 ? 'Je hebt een speciale kaart verzameld!' : `Je had wel ${score} van de 6 vragen goed!`}</H1>
				<PrimaryButton onClick={() => {
					goBack();
					tag.sendClick('unlocked-card', {
						chapter3: card.id,
						name: 'back-pressed',
					});
				}}>Open</PrimaryButton>
			</>}
		</div>
	</BottomSheet>;
};

UnlockedCardMessage.propTypes = {
	foundAt: PropTypes.string.isRequired,
	score: PropTypes.number.isRequired,
	openCollection: PropTypes.func,
	goBack: PropTypes.func,
	card: PropTypes.shape({
		id: PropTypes.any
	}).isRequired
}

UnlockedCardMessage.defaultProps = {
	openCollection: undefined,
	goBack: undefined,
}

export default UnlockedCardMessage;
